<template>
    <div class="row mb-3">
        <div class="col" v-for="usulan in data.r_usulan" v-bind:key="usulan">
            <div class="card card-body p-3">
                <ul class="list-group">
                    <li class="border-0 list-group-item d-flex justify-content-between border-radius-lg ps-0" v-if="usulan.status == 'Selesai Unggah Usulan'">
                        <div class="d-flex align-items-center">
                            <div class="d-flex flex-column">
                                <h6 class="mb-1 text-sm text-dark">{{ usulan.status }}</h6>
                                <div class="d-flex justify-content-start">
                                    <a :href="this.baseUrl + 'storage/hasil_uji/' + usulan.unggah_lhu" class="btn bg-gradient-primary btn-xs">Unduh LHU</a>
                                    <a :href="this.baseUrl + 'storage/hasil_uji/' + usulan.unggah_hasil" class="btn bg-gradient-primary btn-xs ms-2">Unduh Lampiran</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="mb-2 border-0 list-group-item d-flex justify-content-between border-radius-lg ps-0 " v-for="tracking in usulan.r_log" v-bind:key="tracking">
                        <div class="d-flex align-items-center">
                            <div class="text-center shadow icon icon-shape icon-sm bg-gradient-dark me-3">
                            </div>
                            <div class="d-flex flex-column">
                                <h6 class="mb-1 text-sm text-dark">{{ tracking.message }}</h6>
                                <span class="text-xs">{{ moment(tracking.created_at).format('MMMM Do YYYY, h:mm a') }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-12">
        <div class="card card-body p-3">
            <ul class="list-group">
                <li class="mb-2 border-0 list-group-item d-flex justify-content-between border-radius-lg ps-0 " v-for="tracking in this.data.r_log" v-bind:key="tracking">
                    <div class="d-flex align-items-center">
                        <div class="text-center shadow icon icon-shape icon-sm bg-gradient-dark me-3">
                        </div>
                        <div class="d-flex flex-column">
                            <h6 class="mb-1 text-sm text-dark">{{ tracking.message }}</h6>
                            <span class="text-xs">{{ moment(tracking.created_at).format('MMMM Do YYYY, h:mm a') }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
</div>
</template>

<script>

import moment from 'moment';
export default {
    name: "Tracking",
    data() {
        return {
            id: this.$route.params.id,
            baseUrl: process.env.VUE_APP_URL,
            data: {},
        }
    }, mounted() {
        this.axios.get('pengajuan/' + this.id).then((response) => {
            this.data = response.data.data;
        });

    }, methods: {

    }, computed: {
        moment() {
            return moment;
        }
    }
}
</script >

